<!-- When no real choices exist -->
<ng-container
  *ngIf="
    !showVariantControl && (!product.selectedMapValue || options.length === 1)
  "
>
  <span class="plain-variant-text">
    <span
      class="color-dot"
      [style.background]="getColorDot(options[0]?.variant1_value)"
    ></span>
    {{ formatOptionText(options[0] || product.selectedMapValue) }}
  </span>
</ng-container>

<!-- When choices exist or an item is selected -->
<ng-container *ngIf="showVariantControl || product.selectedMapValue">
  <!-- Selected state: shown once a variant is picked -->
  <button
    *ngIf="product.selectedMapValue"
    type="button"
    class="variant-badge selected-chip"
    [class.disabled-chip]="product.returned"
    [style.borderColor]="getColorDot(product.selectedMapValue.variant1_value)"
    (click)="!product.returned && togglePanel($event)"
    [title]="product.returned ? 'Sales Return item' : 'Click to change variant'"
  >
    <div class="selected-content">
      <!-- Variant Text Details -->
      <div class="variant-details-text">
        <!-- Display Param1/IMEI if exists -->
        <span *ngIf="product.selectedMapValue.parameter1_value" class="param-detail">
          <span class="label">{{ getParameter1Name() }}: </span>
          <span class="value">{{ product.selectedMapValue.parameter1_value }}</span>
        </span>
        
        <!-- Divider if both exist -->
        <span *ngIf="product.selectedMapValue.parameter1_value && product.selectedMapValue.variant1_value" class="details-divider">|</span>
        
        <!-- Display Variant1/Color if exists -->
        <span *ngIf="product.selectedMapValue.variant1_value" class="variant-detail">
          <span class="label">{{ getVariant1Name() }}: </span>
          <span class="value">{{ product.selectedMapValue.variant1_value }}</span>
        </span>

        <!-- Display Qty if no parameters but qty exists -->
        <!-- <span *ngIf="!product.selectedMapValue.parameter1_value && product.selectedMapValue.qty !== undefined" class="qty-detail">
          <span class="value">Qty: {{ product.selectedMapValue.qty }}</span>
        </span> -->
      </div>
    </div>
    <i *ngIf="!product.returned" class="pi pi-pencil edit-icon"></i>
  </button>

  <!-- Unselected trigger: shown when choices exist but none selected yet -->
  <button
    *ngIf="!product.selectedMapValue"
    type="button"
    class="variant-badge unselected-trigger"
    [class.attention-pulse]="needsAttention"
    (click)="togglePanel($event)"
  >
    <span class="trigger-left">
      <i class="pi pi-tags trigger-icon"></i>
      <span class="trigger-text">Select Variant / IMEI</span>
    </span>
    <i class="pi pi-chevron-down trigger-arrow"></i>
  </button>

  <!-- Centered modal dialog, opened either via the chip above or directly
       via [openSignal] from the parent's sitemap icon. -->
  <p-dialog
    [(visible)]="displayDialog"
    [modal]="true"
    [showHeader]="false"
    [closable]="false"
    [dismissableMask]="false"
    [draggable]="false"
    [resizable]="false"
    styleClass="pos-dlg pos-dlg-md premium-dialog"
    [blockScroll]="true"
    appendTo="body"
  >
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Select Variant / IMEI</h3>
        <p class="premium-subtitle" *ngIf="product.name">{{ product.name }}</p>
      </div>
      <button
        type="button"
        class="premium-close-btn"
        (click)="closeDialog()"
        aria-label="Close"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body variant-body">
      <!-- Search (Only for serialized) -->
      <div class="search-container" *ngIf="isSerialized">
        <span class="p-input-icon-left w-100">
          <i class="pi pi-search"></i>
          <input
            type="text"
            pInputText
            placeholder="Scan or type IMEI..."
            class="w-100 p-inputtext-sm"
            [(ngModel)]="searchQuery"
            (input)="onSearch($event)"
            autocomplete="off"
          />
        </span>
      </div>

      <!-- Modern variant table -->
      <div class="variant-table-wrap">
        <table class="variant-table">
          <thead>
            <tr>
              <th *ngIf="optionHeaders.hasParameter1">
                {{ getOptionNames().parameter1Name }}
              </th>
              <th *ngIf="optionHeaders.hasParameter2">
                {{ getOptionNames().parameter2Name }}
              </th>
              <th *ngIf="optionHeaders.hasVariant1">
                {{ getOptionNames().variant1Name }}
              </th>
              <th *ngIf="optionHeaders.hasBatch">Batch</th>
              <th class="qty-col">Qty</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="filteredOptions.length === 0">
              <td class="no-results" [attr.colspan]="colSpanCount">
                No variants found
              </td>
            </tr>

            <tr
              *ngFor="let opt of filteredOptions"
              class="variant-row"
              [class.out-of-stock]="opt.qty <= 0"
              [class.active]="product.selectedMapValue?.id === opt.id"
              (click)="selectVariant(opt)"
            >
              <td *ngIf="optionHeaders.hasParameter1" class="primary-cell">
                {{ opt.parameter1_value || "-" }}
              </td>

              <td *ngIf="optionHeaders.hasParameter2" class="secondary-cell">
                {{ opt.parameter2_value || "-" }}
              </td>

              <td *ngIf="optionHeaders.hasVariant1" class="variant-cell">
                <span
                  class="color-dot"
                  [style.background]="getColorDot(opt.variant1_value)"
                  *ngIf="opt.variant1_value"
                ></span>
                {{ opt.variant1_value || "-" }}
              </td>

              <td *ngIf="optionHeaders.hasBatch" class="batch-cell">
                {{ opt.batch == 'opens012' ? "Opening stock"  : opt.batch}}
              </td>

              <td class="qty-col">
                <span *ngIf="opt.qty > 0" class="qty-badge">{{ opt.qty }}</span>
                <span *ngIf="opt.qty <= 0" class="oos-text">OOS</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </p-dialog>
</ng-container>